export interface BlockFileEntry {
	index: number;
	type: "image" | "video";
	file: File;
}

export interface AnnouncementFormValues {
	notificationType: "announcement" | "push";
	title: string;
	body: string;
	heroImage: File | null;
	pushTitle: string;
	pushBody: string;
	audienceType: "everyone" | "platform" | "groups" | "users";
	audiencePlatform: "ios" | "android" | "both";
	audienceUserIds: string[];
	scheduleType: "now" | "scheduled";
	scheduledDate: string;
	scheduledTime: string;
	hasExpiry: boolean;
	expiryDate: string;
	expiryTime: string;
	blockFiles: BlockFileEntry[];
	contentBlocks: MeeAnnouncementContentBlock[];
}

export function formValuesToAnnouncement(
	data: AnnouncementFormValues,
	id?: number
): Partial<MeeAnnouncement> {
	const scheduledAt =
		data.scheduleType === "scheduled" && data.scheduledDate
			? `${data.scheduledDate}T${data.scheduledTime || "00:00"}:00`
			: null;

	const expiresAt =
		data.hasExpiry && data.expiryDate
			? `${data.expiryDate}T${data.expiryTime || "00:00"}:00`
			: null;

	return {
		...(id !== undefined && { id }),
		title: data.title,
		body: data.body || null,
		pushTitle: data.pushTitle || null,
		pushBody: data.pushBody || null,
		audienceType: data.audienceType,
		audiencePlatform:
			data.audienceType === "platform" ? data.audiencePlatform : null,
		audienceUserIds: data.audienceType === "users" ? data.audienceUserIds : [],
		contentBlocks: data.contentBlocks,
		scheduledAt,
		expiresAt
	};
}
